import React, { Component } from "react";
import { connect } from "react-redux";
import { OnePageHeader, SrhJumbotron, WatermarkedDiv } from "./style.js";
import SRHCopyright from "./../../../../components/SRHCopyright";
import Printable from "./../../../../components/Printable";
import logo from "./../../../../assets/img/logo/logo-stacked.png";
import FiltersFooter from "../FiltersFooter";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";

class TitlePage extends Component {
  summaryReportHeaderContents = (summaryReport, unit, filters) => {
    let title = `${summaryReport.survey.replace(/_/g, " ")} Survey Summary Report`;
    if (summaryReport.configuration && summaryReport.configuration.custom_title) {
      title = summaryReport.configuration.custom_title;
    } else if (/SUTTER_Pulse/.test(summaryReport.actualSurvey)) {
      title = "COS Survey Summary Report";
    } else if (/SELECT_2020/.test(summaryReport.actualSurvey) || /SHA_2020/.test(summaryReport.actualSurvey)) {
      title = 'SCORE Survey Summary Report';
    } else if (/VALLEY_2020/.test(summaryReport.actualSurvey)) {
      title = 'SCOR Survey Summary Report';
    }

    const nameWithPeriod = `${summaryReport.datasetName} - ${summaryReport.surveyPeriod}`;
    const datasetUnitName = summaryReport.datasetUnitNamePlural ? summaryReport.datasetUnitNamePlural : "Work Settings";
    return (
      <div>
        <h1>{title}</h1>
        <h2
          className={
            nameWithPeriod.length <= 45
              ? ""
              : nameWithPeriod.length <= 55
              ? "smaller-x1"
              : nameWithPeriod.length <= 65
              ? "smaller-x2"
              : nameWithPeriod.length <= 75
              ? "smaller-x3"
              : nameWithPeriod.length <= 85
              ? "smaller-x4"
                      : nameWithPeriod.length <= 100 ? "smaller-x5" : "truncate"
          }
        >
          {nameWithPeriod}
        </h2>
        {!(/TRINITY_2020_PEEK/.test(summaryReport.actualSurvey)) && 
          <h4>
          {/SUTTER_Pulse/.test(summaryReport.actualSurvey)
            ? ""
            : `${summaryReport.workSettingsSurveyed} ${datasetUnitName} - `}
            
            {filters && filters.count >= 0
              ? `${filters.count} Respondents - ${filters.summary}`
              : `${summaryReport.unit ? unit.responseCount : summaryReport.totalRespondents} Respondents - Response Rate ${summaryReport.responseRate}%`}
          </h4>
        }
      </div>
    );
  };

  unitSummaryReportHeaderContents = (summaryReport, unit, filters) => {
    const reportName = unit.name === summaryReport.datasetName && summaryReport.datasetEntityName 
      ? summaryReport.datasetEntityName
      : unit.name;

    const nameWithPeriod = `${reportName} - ${summaryReport.surveyPeriod}`;

    let surveyTitle = `${summaryReport.survey.replace(/_/g, " ")} Survey Summary Report`;
    if (summaryReport.configuration && summaryReport.configuration.custom_title) {
      surveyTitle = summaryReport.configuration.custom_title;
    } else if (/PENN.*_Pulse_2020/.test(summaryReport.survey)) {
      surveyTitle = 'SCORE Survey Summary Report';
    } else if (/SELECT_2020/.test(summaryReport.actualSurvey)) {
      surveyTitle = 'SCORE Survey Summary Report';
    }

    return (
      <div>
        <h1>{surveyTitle}</h1>
        <h2
          className={
            nameWithPeriod.length <= 45
              ? ""
              : nameWithPeriod.length <= 55
              ? "smaller-x1"
              : nameWithPeriod.length <= 65
              ? "smaller-x2"
              : nameWithPeriod.length <= 75
              ? "smaller-x3"
              : nameWithPeriod.length <= 85
              ? "smaller-x4"
                      : nameWithPeriod.length <= 100 ? "smaller-x5" : "truncate"
          }
        >
          {nameWithPeriod}
        </h2>
        <h3>{summaryReport.datasetName}</h3>
        {!(/TRINITY_2020_PEEK/.test(summaryReport.actualSurvey)) &&
          <h4>
            {filters && filters.count >= 0
              ? `${filters.count} Respondents - ${filters.summary}`
            : `${unit.responseCount} Respondents ${unit.responseRate ? ` - Response Rate ${unit.responseRate}%` : ""}`
          }
          </h4>
        }

      </div>
    );
  };

  render() {
    let { summaryReport, unit, ready, landscape, filters } = this.props;
    let header;
    const landscapeClass = { landscape };

    if (ready) {
      if (!unit || /SUTTER_Pulse/.test(summaryReport.actualSurvey)) {
        header = this.summaryReportHeaderContents(summaryReport, unit, filters);
      } else if (unit) {
        header = this.unitSummaryReportHeaderContents(summaryReport, unit, filters);
      }
      return (
        <Printable landscape={landscape}>
          <OnePageHeader className={clsx(landscapeClass)}>
            <img src={logo} alt="Logo" />
          </OnePageHeader>
          <SrhJumbotron className={clsx(landscapeClass)}>{header}</SrhJumbotron>
          <WatermarkedDiv>
            <Grid container spacing={2}>
              {!/SUTTER_Pulse/.test(summaryReport.actualSurvey) ? (
                <Grid item xs={6}>
                  <h4>The Value of an Integrated Survey</h4>
                  
                  {/SOPS/.test(summaryReport.actualSurvey) ? (<div>
                    <p>The {summaryReport.configuration.survey_type || 'SOPS'} surveys measure important dimensions of
                    organizational culture. The core instrument integrates safety
                    and teamwork culture, local leadership, and learning
                    systems.</p>
                    <p>The insights are critical for organizational improvement and the ability to drive habitual excellence.</p>
                    <p>Specific actions can be taken to leverage organizational strengths and address areas of fundamental opportunity.</p>
                    </div>
                  ) : (<div>
                    {/TRINITY/.test(summaryReport.actualSurvey) ? (<p>
                      The SCORE survey measures important dimensions of organizational culture and employee engagement. The core instrument integrates safety and teamwork culture, local leadership, learning systems, resilience/burnout and work-life balance.
                    </p>) : (
                      <p>
                      The SCOR survey measures important dimensions of organizational culture. The core instrument
                      integrates safety and teamwork culture, local leadership, learning systems, resilience/burnout and
                      work-life balance. The full SCORE survey integrates employee engagement as well.
                    </p>)}

                    <p>
                      The insights are critical for organizational improvement and the ability to drive habitual
                      excellence.
                    </p>
                    <p>
                      Specific actions can be taken to leverage organizational strengths and address areas of fundamental
                      opportunity.
                    </p>
                  </div>)}

                </Grid>
              ) : (
                <Grid item xs={6}>
                  <h4>The Value of a Safety Culture Survey</h4>
                  <p>
                    The SCOR survey measures important dimensions of organizational culture. The core instrument
                    integrates safety and teamwork culture, local leadership, learning systems, resilience/burnout and
                    work-life balance.
                  </p>
                  <p>
                    The insights are critical for organizational improvement and the ability to drive habitual
                    excellence.
                  </p>
                  <p>
                    Specific actions can be taken to leverage organizational strengths and address areas of fundamental
                    opportunity.
                  </p>
                </Grid>
              )}
              <Grid item xs={6}>
                <h4>Why is Culture Important?</h4>
                <p>It reflects the behaviors and beliefs within the organization.</p>
                <p>There are behaviors that create value individually, for the patient and the organization.</p>
                <p>There are behaviors that create unacceptable risk.</p>
                <p>
                  These attitudes and behaviors are reflected in how people interact with each other both internally and
                  externally with patients and their families.
                </p>
                <p>Culture is the social glue.</p>
              </Grid>
            </Grid>
          </WatermarkedDiv>
          {/* <FiltersFooter fullWidth /> */}
          <SRHCopyright textClass={"large-font"} noImage />
        </Printable>
      );
    } else {
      return <Printable landscape={landscape} />;
    }
  }
}
export default connect(store => {
  return {
    summaryReport: store.summaryReport.summaryReport,
    filters: store.filters
  };
})(TitlePage);



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/TitlePage/index.jsx